import React, { useEffect, useState } from "react";
import { errorStatusHandle } from "../../utils/error-utils";
import { useDocumentTitle } from "../../hooks";
import { useDispatch } from "react-redux";
import { getPositionImportPageSettings } from "../../api/setting/pageApi";
import { setPageSettings } from "../../store/actions/pageActions";
import { getRouteBreadcrumb } from "../../services/BreadcrumbServices";
import { POSITION_MASTER_IMPORT } from "../../constants/routes";
import { importPositions } from "../../api/position/positionImportApi";
import {FileTemplateDownloader, FileUploader, RedirectAlert} from "../../components";
import { API_POSITION_DOWNLOAD_TEMPLATE } from "../../constants/api";
import { PageTitle } from "../../components";
import BackendLayout from "../../layouts/BackendLayout";
import PageAlert from "../../components/alerts/PageAlert";
import {
  resetAlert,
  setImportFileAlertError,
  setAlertSuccess,
  setPageLoading,
  clearPageLoading,
  setButtonProcessing,
  clearButtonProcessing
} from "../../store/actions";
import {POSITION_MASTER_IMPORT_PAGE} from "../../constants/pageName";
import useRedirectPage from "../../hooks/useRedirectPage";

function PositionImportPage() {
  useRedirectPage(POSITION_MASTER_IMPORT_PAGE);
  const [processing, setProcessing] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const dispatch = useDispatch();

  const setPositionImportPageSettings = async (e) => {
    dispatch(setPageLoading());
    const pageSettings = await getPositionImportPageSettings();
    dispatch(setPageSettings(pageSettings));
    dispatch(clearPageLoading());
  };

  useEffect(() => {
    setPositionImportPageSettings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const breadcrumb = getRouteBreadcrumb(POSITION_MASTER_IMPORT);
  useDocumentTitle("職位マスタインポート - 点検王");

  const handleChangeFileChange = (file) => {
    setSelectedFile(file);
    dispatch(resetAlert());
  };

  const BUTTON_IMPORT_POSITION = 'button__import-position';
  const handleUpload = () => {
    dispatch(setButtonProcessing(BUTTON_IMPORT_POSITION));
    dispatch(resetAlert());
    const formData = new FormData();
    formData.append("file", selectedFile);
    importPositions(formData)
      .then((response) => {
        dispatch(setAlertSuccess(response.message));
        setSelectedFile(null);
      })
      .catch((error) => {
        errorStatusHandle(error);
        if (error.status === 400) {
          let responseData = error.data;
          dispatch(setImportFileAlertError(responseData));
        }
      }).finally(() => {
        dispatch(clearButtonProcessing(BUTTON_IMPORT_POSITION));
    });
  };

  return (
    <BackendLayout breadcrumb={breadcrumb}>
      <PageTitle title="職位マスタインポート" />
      <RedirectAlert />
      <PageAlert />
      <div className="lg:flex mt-6 2xl:space-x-[32px] xl:space-x-[28px] lg:space-x-[24px] lg:space-y-0 md:space-y-[24px]">
        <FileUploader
          title="ファイルをアップロード"
          description="職位をインポートしたいファイルをアップロードしてください"
          file={selectedFile}
          handleUpload={handleUpload}
          handleChangeFileChange={handleChangeFileChange}
          buttonId={BUTTON_IMPORT_POSITION}
        />
        <FileTemplateDownloader
          title="テンプレートファイル"
          description="テンプレートファイルを持っていない場合、インポートに使用するファイルをこちらからダウンロードしてください。"
          apiUrl={API_POSITION_DOWNLOAD_TEMPLATE}
        />
      </div>
    </BackendLayout>
  );
}

export default PositionImportPage;
